import { render, staticRenderFns } from "./DetailsPanel.vue?vue&type=template&id=6cb7fe7d&scoped=true"
import script from "./DetailsPanel.vue?vue&type=script&lang=js"
export * from "./DetailsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb7fe7d",
  null
  
)

export default component.exports